(() => {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
parcelRequire.register("e5wvA", function(module, exports) {

$parcel$export(module.exports, "toggleNavbarBurger", () => $a41abfd53489cccd$export$6a121a948903e9ac);
function $a41abfd53489cccd$export$6a121a948903e9ac(navbarElement) {
    const navbarBurgers = navbarElement.querySelector(".navbar-burger");
    navbarBurgers.addEventListener("click", ()=>{
        const dataTarget = navbarBurgers.dataset.target;
        const target = document.getElementById(dataTarget);
        navbarBurgers.classList.toggle("is-active");
        target.classList.toggle("is-active");
    });
    navbarElement.querySelectorAll(".navbar-link-icons").forEach(function(navbarLink) {
        navbarLink.addEventListener("click", (event)=>{
            event.preventDefault();
            navbarLink.parentElement.nextElementSibling.classList.toggle("is-hidden-mobile");
            navbarLink.parentElement.classList.toggle("icon-switched");
        });
    });
}

});

})();
//# sourceMappingURL=navbar.db27ce9a.js.map
